"use client";

import { useEffect, useRef, useState } from "react";

export function useCopyAcknowledgement({
  text,
  onCopy,
}: Readonly<{
  text: string;
  onCopy: (text: string) => Promise<void>;
}>) {
  // Acknowledgement belongs to the copied command; changing options must preserve keyboard focus.
  const [copiedText, setCopiedText] = useState<string | null>(null);
  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(
    () => () => {
      if (timeout.current !== null) clearTimeout(timeout.current);
    },
    [],
  );

  const copy = async () => {
    await onCopy(text);
    setCopiedText(text);

    if (timeout.current !== null) clearTimeout(timeout.current);

    timeout.current = setTimeout(() => setCopiedText(null), 1800);
  };

  return { copied: copiedText === text, copy };
}
